import { AttendanceCode } from '@schooly/api';
import {
  AttendanceCodeAction,
  AttendanceCodeInSchool,
  AttendanceCodeIsPresent,
} from '@schooly/constants';

export type AttendanceCodeCreate = Omit<AttendanceCode, 'id' | 'order'> & {
  action?: AttendanceCodeAction;
};

export const generateEmptyAttendanceCode = (): AttendanceCodeCreate => ({
  name: '',
  description: '',
  code: '',
  in_school: true,
  is_present: true,
  has_push_notifications: false,
  has_justification: false,
});

export const getDefaultCodeFormValues = (code: AttendanceCodeCreate | AttendanceCode) => {
  let action = AttendanceCodeAction.NoAction;
  if (code.has_push_notifications) {
    action = AttendanceCodeAction.NotifyParents;
  }
  if (code.has_justification) {
    action = AttendanceCodeAction.RequestJustification;
  }

  return {
    ...code,
    in_school: code.in_school ? AttendanceCodeInSchool.OnPremises : AttendanceCodeInSchool.Outside,
    is_present: code.is_present ? AttendanceCodeIsPresent.Present : AttendanceCodeIsPresent.Absent,
    action,
  };
};
